import { Button } from "devextreme-react";

export default function NameCell(props) {
  const { data } = props;

  return (
    <>
      <div
        style={{
          float: "left",
          marginTop: "5px",
        }}
      >
        {data.value}
      </div>
      {data.data.invRecip == "1" && (
        <Button
          style={{
            margin: 0,
            float: "left",
            height: "20px",
          }}
          icon="fa-solid fa-file-invoice-dollar"
        />
      )}
    </>
  );
}
